import React, { useState, useEffect } from 'react';
import logo from '../../Assets/img/logo-small.png';
import Api from '../../component/Api';
import '../../Assets/css/vendors/bootstrap.css';
import { useNavigate } from 'react-router-dom';

function Login() {
    const { http } = Api();
    const [client_id, setClientId] = useState(false);
    const [finalurl, setFinalUrl] = useState(false);
    const [loginError, setLoginError] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [userId, setUserID] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [userIDError, setUserIDError] = useState(''); //20/3/2024
    const [passwordError, setPasswordError] = useState(''); //20/3/2024

    localStorage.removeItem('token'); // To prevent users from navigating back to the previous page after arriving at the login page


    const navigate = useNavigate();


    useEffect(() => {
        const error = localStorage.getItem('validationerror');
        if (error) {
            setLoginError(error);
        }

        const hostname = window.location.origin;
        if (hostname === "https://edp.mgu.ac.in") {
            setClientId("807429d3-44cd-11ef-9571-ec2a72ece818");
        } else {
            setClientId("d5584812-4289-11ef-9571-ec2a72ece818");
        }
    }, []);

    useEffect(() => {
        if (client_id) {
            http.get(`getCredentials`, { params: { client_id: client_id } })
                .then((result) => {
                    const target = result.data.target_url;
                    const redirect = result.data.redirect_url;

                    const newUrl = new URL(target);
                    newUrl.searchParams.append('redirect_url', redirect);
                    setFinalUrl(newUrl.toString());
                })
                .catch((error) => {
                    console.error("Error fetching credentials:", error);
                });
        }
    }, [client_id, http]);

    const handleLoginWithPortal = () => {
        window.location.href = finalurl;
    };


    const submitForm = (e) => {
        e.preventDefault(); // Prevent default form submission

        if (!password && !userId) {
            setUserIDError('Please enter valid User ID');
            setPasswordError('Please enter valid password');
            document.getElementById('exampleInputUserId').focus();
        } else if (!password) {
            setPasswordError('Please enter valid Password');
            setUserIDError('');
            document.getElementById('exampleInputPassword').focus();
        } else if (!userId) {
            setPasswordError('');
            setUserIDError('Please enter valid User ID');
            document.getElementById('exampleInputUserId').focus();

        } else {
            // Reset login field error state if both fields have input
            setUserIDError('');
            setPasswordError('');

            http.post('/collegelogin', { user_id: userId, password: password })
                .then(res => {
                    if (res.data.token) {
                        console.log("token=", res.data.token);
                        localStorage.setItem('token', res.data.token);
                        navigate('/college/collegedashboard'); // Use relative path
                    } else {
                        setLoginError('Login failed. Please try again.');
                    }
                })
                .catch(error => {
                    console.error('Login error:', error);
                    setLoginError('Invalid Username or Password');
                });
        }
    };

    return (
        <div className="container-fluid bg-gradient-primary">
            <div className="row justify-content-center flex-grow-1">
                <div className="col-xl-5 col-lg-12 col-md-9">
                    <div className="o-hidden border-0 shadow-lg my-5 brd-rad bk-clr">
                        <div className="card-body p-0">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="p-4">
                                        <div className="circle23">
                                            <img className="img-fluid for-light" src={logo} alt="MGU Logo" />
                                        </div>
                                        <div className="heading12 text-center" style={{marginBottom:'0px'}}>Sign in to Your Account</div>
                                        <br />
                                        <form onSubmit={submitForm}>
                                            <div className="user mt-2">
                                                {loginError && (
                                                    <div className="alert alert-danger" role="alert">
                                                        <p style={{ textAlign: 'center', textJustify: 'auto' }}>{loginError}</p>
                                                    </div>
                                                )}

                                                <div className="form-group">

                                                    <input
                                                        type="text"
                                                        className="form-control "
                                                        id="exampleInputUserId"
                                                        placeholder="User ID"
                                                        onChange={(e) => setUserID(e.target.value)}
                                                        style={{ width: '100%' }}
                                                    />
                                                    {userIDError && <p className="text-danger">{userIDError}</p>}
                                                </div>
                                                <br></br>

                                                <div className="form-group">

                                                    <div className="form-input position-relative">
                                                        <div style={{ position: 'relative' }}>
                                                            <input

                                                                type={showPassword ? "text" : "password"}
                                                                className="form-control form-control-user"
                                                                id="exampleInputPassword"
                                                                placeholder="***********"
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                style={{ width: '100%' }}

                                                            />
                                                            <span className="show-hide" style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', right: '10px', cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                                                                {showPassword ? <i className="fa fa-eye-slash fa-stl"></i> : <i className="fa fa-eye fa-stl"></i>}
                                                            </span>

                                                        </div>
                                                    </div>
                                                    {passwordError && <p className="text-danger">{passwordError}</p>}
                                                </div>
                                                <br></br>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-user btn-block bt"

                                                    style={{ width: '100%' }}
                                                >
                                                    <h6>Login</h6>
                                                </button>
                                            </div>
                                        </form>

                                        <div className="divider mt-4 mb-3">
                                            <span className="divider-text">Or</span>
                                        </div>

                                        {/* Login with College Portal */}
                                        <div className="portal-login-section">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-user btn-block bt"
                                                onClick={handleLoginWithPortal}
                                                style={{ width: '100%' }}
                                            >
                                                Login with College Portal
                                            </button>
                                        </div>

                                        <marquee behavior="scroll" direction="left" scrollamount="4">
                                            {/* <div>
                                                <strong className="text-danger m-t-5">
                                                    The EDP Portal will be temporarily unavailable from 1:00 PM to 3:00 PM on 31.01.2026 due to scheduled  maintenance
                                                </strong>
                                            </div> */}

                                        </marquee>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className="footer foot-wt">
                <div className="container my-auto">
                    <div className="copyright text-center my-auto">
                        <span style={{ color: 'black' }}>
                            &copy; <a style={{ color: 'black' }} href="https://www.mgu.ac.in/" target="_blank" rel="noopener noreferrer">Mahatma Gandhi University, Priyadarsini Hills, Kottayam, Kerala, India - 686560</a>
                        </span>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Login;
